import './polyfills';
import { createRoot } from "react-dom/client";
import ChatWidget from "./ChatWidget";
import './index.css'


const container = document.getElementById('chat-widget-root')
if(container){
    const root = createRoot(container)
    root.render(<ChatWidget />)
}

